import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
export var Filled = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var theme = _ref.theme,
    isFavorite = _ref.isFavorite;
  return _objectSpread({
    color: theme.palette.pink[300],
    display: 'none'
  }, isFavorite && {
    display: 'flex'
  });
});
export var Outlined = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref2) {
  var theme = _ref2.theme,
    isFavorite = _ref2.isFavorite;
  return _objectSpread({
    color: theme.palette.text.secondary,
    display: 'flex'
  }, isFavorite && {
    display: 'none'
  });
});
export var HeartIconRoot = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    alignItems: 'center',
    display: 'flex',
    fontSize: 'inherit',
    height: '100%',
    justifyContent: 'center',
    width: '100%'
  }, theme.breakpoints.up('md'), {
    '&:hover .filledIcon': {
      display: 'flex'
    },
    '&:hover .outlinedIcon': {
      display: 'none'
    }
  });
});
//# sourceMappingURL=styles.js.map